<template>
  <div class="d-flex flex-column flex-root  bg-white">
    <router-view></router-view>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'LayoutLoginView',
  components: {
  }
}
</script>
